import {
  Button,
  FlatTreeItem,
  FlatTreeItemProps,
  Tooltip,
  TreeItemLayout,
  useRestoreFocusTarget,
} from "@fluentui/react-components";
import { AddCircle20Regular } from "@fluentui/react-icons";
import { forwardRef, useCallback } from "react";
import { makeStyles } from "@fluentui/react-components";
import { SkanskaColorTokens } from "../../style/colors";
import { useTranslation } from "react-i18next";
import { FlatVsaaTag } from "../../models/VsaaTag";

type TagTreeItemProps = FlatTreeItemProps & {
  tag: FlatVsaaTag;
  tagCollectionId: string;
  onClickCreate: (parentTag?: FlatVsaaTag) => void;
};

const useStyles = makeStyles({
  createButton: {
    margin: "0 10px",
  },
  confirmDeleteButton: {
    backgroundColor: SkanskaColorTokens.color_tertiary_red_30,
    ":hover": {
      backgroundColor: SkanskaColorTokens.color_tertiary_red,
      color: SkanskaColorTokens.color_secondary_white,
    },
    ":focus": {
      backgroundColor: SkanskaColorTokens.color_tertiary_red,
      color: SkanskaColorTokens.color_secondary_white,
    },
  },
  menuItems: {
    margin: "5px 0",
    alignContent: "center",
  },
  icons: {
    verticalAlign: "middle",
  },
});

const TagTreeItem = forwardRef(
  (
    { tag, onClickCreate, ...props }: TagTreeItemProps,
    ref: React.Ref<HTMLDivElement> | undefined
  ) => {
    const focusTargetAttribute = useRestoreFocusTarget();

    const { t } = useTranslation();

    const handleCreateClick = useCallback(() => {
      onClickCreate(tag);
    }, [tag, onClickCreate]);

    const classes = useStyles();

    return (
      <>
        <FlatTreeItem
          aria-description="has actions"
          {...focusTargetAttribute}
          {...props}
          ref={ref}
        >
          <TreeItemLayout
            actions={
              <>
                <Button
                  className={classes.createButton}
                  aria-label={t("newTag")}
                  onClick={handleCreateClick}
                  icon={<AddCircle20Regular className={classes.icons} />}
                >
                  {t("newTag")}
                </Button>
              </>
            }
          >
            {tag.path && tag.path.includes("/") ? (
              <Tooltip content={tag.path} relationship="label">
                <span>{props.children} </span>
              </Tooltip>
            ) : (
              <span>{props.children} </span>
            )}
          </TreeItemLayout>
        </FlatTreeItem>
      </>
    );
  }
);

export default TagTreeItem;
